import { withEditable } from '../../../HOCs/withEditable';
import withDayArray from '../../../HOCs/withDayArray';
import ModalSlider from '../../Places/ModalSlider';

export const EditableSliderForDay = withDayArray(withEditable(ModalSlider));



// WEBPACK FOOTER //
// ./src/screens/Trek/ThemesModal/EditableSliderForDay.js